import { Box } from '@factorialco/deprecated-design-system'

import { NotesTextEditorWithUpload } from 'modules/core/components/NotesTextEditorWithUpload'

import { editorAlignmentOffset } from 'modules/trainings/components/content/items/shared/styles.vanilla.css'

export type InlineEditableDescriptionProps = {
  value: string
  readOnly: boolean
  onChange: (value: string) => void
  editorKey: string
  placeholder: string
  trainingId: string
}

export const InlineEditableDescription = ({
  value,
  readOnly,
  onChange,
  editorKey,
  placeholder,
  trainingId,
}: InlineEditableDescriptionProps) => {
  const parseDescriptionContent = (description: string) => {
    if (!description) return ''
    try {
      return JSON.parse(description)
    } catch {
      return description
    }
  }

  return (
    <Box className={editorAlignmentOffset}>
      <NotesTextEditorWithUpload
        key={editorKey}
        resourceType="Trainings::Training"
        resourceId={trainingId}
        initialEditorState={{
          content: parseDescriptionContent(value),
        }}
        placeholder={placeholder}
        onChange={({ json }) => {
          onChange(JSON.stringify(json))
        }}
        readonly={readOnly}
        withPadding={false}
        showBubbleMenu={!readOnly}
      />
    </Box>
  )
}
